import React from 'react';
import { motion } from 'framer-motion'; 
import { Phone, Wifi, ShieldCheck, ArrowRight, Instagram, Wind, Tv, MapPin } from 'lucide-react';

function App() {
  const handleWA = () => {
    window.open('https://wa.me/6282195073008?text=Halo%20Admin%20Sunrise%20House,%20saya%20tertarik%20dengan%20Standard%20Room...', '_blank');
  };

  return (
    <div className="font-sans text-gray-800 bg-white">

      {/* 1. NAVBAR */}
      <nav className="fixed w-full z-50 bg-white/95 backdrop-blur-md shadow-sm py-4 px-6 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-2xl">☀️</span>
          <h1 className="text-xl font-bold tracking-tight text-gray-900">Sunrise House (Website Under Construction.. !!!)</h1>
        </div>
        <button onClick={handleWA} className="bg-orange-600 text-white px-5 py-2 rounded-full font-bold text-sm hover:bg-orange-700 transition flex items-center gap-2 shadow-lg">
          <Phone size={16} /> Hubungi Kami
        </button>
      </nav>

      {/* 2. HERO SECTION */}
      <header className="relative h-screen flex items-center justify-center overflow-hidden bg-gray-900">
        <div className="absolute inset-0 z-0 opacity-60">
          <img 
            src="https://images.unsplash.com/photo-1522771753033-d4692b913192?q=80&w=2070&auto=format&fit=crop" 
            alt="Sunrise House Lobby" 
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mt-10">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm md:text-lg font-bold mb-4 text-orange-400 tracking-[0.3em] uppercase">GUest House & Kost Exclusive</h2>
            <h1 className="text-5xl md:text-7xl font-extrabold mb-6 leading-tight drop-shadow-lg">
              Hunian Nyaman <br/> Jantung Kota Makassar
            </h1>
            <p className="text-lg md:text-xl text-gray-200 mb-10 font-light max-w-2xl mx-auto drop-shadow-md">
              Jl. Andi Djemma No. 63A. Fasilitas lengkap, dan strategis.
            </p>
            
            <button onClick={handleWA} className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-full font-bold text-lg transition transform hover:scale-105 flex items-center justify-center gap-2 shadow-orange-900/50 shadow-xl mx-auto">
              Booking Sekarang <ArrowRight size={20}/>
            </button>
          </motion.div>
        </div>
      </header>

      {/* 3. STANDARD ROOM ONLY */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
            <div className="text-center mb-16">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Standard Room</h2>
                <p className="text-gray-500 max-w-2xl mx-auto">Kamar andalan kami dengan desain minimalis modern, dirancang untuk kenyamanan istirahat Anda.</p>
            </div>

            <div className="grid md:grid-cols-2 gap-12 items-center">
                {/* Foto Kamar (Link Baru yang Stabil) */}
                <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white relative group h-96 bg-gray-100">
                    <img 
                        src="https://images.unsplash.com/photo-1505691938895-1758d7feb511?q=80&w=2070&auto=format&fit=crop" 
                        alt="Standard Room Interior" 
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                    />
                    <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur px-4 py-2 rounded-lg text-sm font-bold shadow-sm text-gray-900">
                        ⭐ Paling Laris
                    </div>
                </div>

                {/* Detail Fasilitas */}
                <div className="space-y-8">
                    <div className="grid grid-cols-2 gap-6">
                        <div className="flex gap-4">
                            <div className="bg-orange-50 p-3 rounded-xl text-orange-600 h-fit"><Wind size={24}/></div>
                            <div>
                                <h4 className="font-bold text-gray-900">Full AC</h4>
                                <p className="text-sm text-gray-500">Dingin & Sejuk</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="bg-blue-50 p-3 rounded-xl text-blue-600 h-fit"><Wifi size={24}/></div>
                            <div>
                                <h4 className="font-bold text-gray-900">Free WiFi</h4>
                                <p className="text-sm text-gray-500">WaringinNet High Speed</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="bg-green-50 p-3 rounded-xl text-green-600 h-fit"><Tv size={24}/></div>
                            <div>
                                <h4 className="font-bold text-gray-900">TV Digital</h4>
                                <p className="text-sm text-gray-500">Hiburan di kamar</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="bg-purple-50 p-3 rounded-xl text-purple-600 h-fit"><ShieldCheck size={24}/></div>
                            <div>
                                <h4 className="font-bold text-gray-900">CCTV 24 Jam</h4>
                                <p className="text-sm text-gray-500">Aman & Tenang</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                        <p className="text-sm text-gray-500 uppercase tracking-widest mb-2">Harga Spesial</p>
                        <div className="flex items-end gap-2 mb-4">
                            <span className="text-4xl font-extrabold text-gray-900">Rp 2.000.000</span>
                            <span className="text-gray-500 mb-1">/ bulan</span>
                        </div>
                        <p className="text-xs text-gray-400 mb-4">*Tersedia juga opsi Harian & Mingguan</p>
                        <button onClick={handleWA} className="w-full bg-gray-900 text-white py-3 rounded-xl font-bold hover:bg-gray-800 transition">
                            Tanya Ketersediaan
                        </button>
                    </div>
                </div>
            </div>
        </div>
      </section>

      {/* 4. LOKASI (TITIK AKURAT SUNRISE HOUSE) */}
      <section className="py-20 bg-gray-900 text-white">
         <div className="container mx-auto px-6 text-center">
             <h2 className="text-3xl font-bold mb-8">Lokasi Strategis</h2>
             
             <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-gray-700 h-96 w-full max-w-4xl mx-auto relative">
                <iframe 
                    src="https://maps.google.com/maps?q=Sunrise%20House%20Jl.%20Andi%20Djemma%20No.63A%20Makassar&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    width="100%" 
                    height="100%" 
                    style={{border:0, filter: 'invert(90%) hue-rotate(180deg)'}} 
                    allowFullScreen="" 
                    loading="lazy"
                    title="Peta Sunrise House"
                ></iframe>
                
                <div className="absolute bottom-4 left-4 bg-white text-gray-900 px-4 py-3 rounded-xl shadow-lg text-left">
                    <p className="font-bold text-sm flex items-center gap-1"><MapPin size={16}/> Sunrise House</p>
                    <p className="text-xs text-gray-500">Jl. Andi Djemma No. 63A, Makassar</p>
                </div>
             </div>

             <div className="mt-10 flex flex-col md:flex-row justify-center gap-4">
                 <button onClick={handleWA} className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full font-bold flex items-center justify-center gap-2 transition">
                    <Phone size={20}/> Chat WhatsApp
                 </button>
                 <button className="bg-gray-800 hover:bg-gray-700 text-white px-8 py-3 rounded-full font-bold flex items-center justify-center gap-2 transition">
                    <Instagram size={20}/> @sunrisehouse_id
                 </button>
             </div>

             <div className="mt-16 pt-8 border-t border-gray-800 text-gray-500 text-sm">
                 © 2025 Sunrise House Makassar.
             </div>
         </div>
      </section>

    </div>
  );
}

export default App;